import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Row, Col, Form, Button, Space, Divider } from "antd"
import { MyInput, MySelect, MySwitch } from "../../Forms"
import { methodsUrl, methodUrlType } from "../../../shared/lookups"
import { MinusOutlined, PlusOutlined } from "@ant-design/icons"
import { ActionButton } from "../../PageComponents"

const Portals= ({form})=>{

    const {portals}= useSelector(state => state?.addEditBox)
    const [urlNumber, setUrlNumber]= useState([])
    const [portalType, setPortalType] = useState(null)

    useEffect(()=>{
        if(portals?.length){
            form.setFieldsValue({
                ...form.getFieldsValue(),
                portals: portals?.map(portal =>({
                    id: portal?.id,
                    urlType: methodUrlType?.find(fin=> fin?.id=== parseInt(portal?.methodType))?.name, 
                    name: portal?.name, 
                    url: portal?.url, 
                    userName: portal?.userName, 
                    password: portal?.password,
                    isLock: portal?.isLock
                }))
            })
            let tempArr= [...portals?.map((portal, index) =>({key: index, value: methodUrlType?.find(fin=> fin?.id=== parseInt(portal?.methodType))?.name}))]
            setUrlNumber(tempArr?.filter(fil=> fil?.value==="Xtreme Code API"))
        }
    }, [portals])

    return (
        <Form.List name="portals">
            {
                (fields, { add, remove }) => (
                    <Space direction="vertical" className="width-100">
                        <Button 
                            type="primary"
                            onClick={() => add()} block icon={<PlusOutlined />}
                            disabled={fields?.length>=5}
                        >
                            Add portal
                        </Button>
                        {
                            fields?.map(({ key, name}) => (
                                <Row 
                                    key={key} 
                                    gutter={[16, 0]} 
                                    align="middle"
                                >
                                    <Col span={0}>
                                        <MyInput
                                            label={null}
                                            name={[name, 'id']}
                                            placeholder='e.g Box1001'
                                        />
                                    </Col>
                                    <Col span={24}>
                                        <MySelect 
                                            label="URL Type"
                                            name={[name, 'urlType']}
                                            required
                                            message="Please choose url type!"
                                            placeholder="Select URL Type"
                                            options={methodUrlType}
                                            onChange={(value)=> {
                                                const isXtream = value === "Xtreme Code API" || value === 3;
                                                if(isXtream)
                                                    setUrlNumber([...urlNumber, {key, value: "Xtreme Code API"}])
                                                else
                                                    setUrlNumber(urlNumber?.filter(fil => fil?.key !== key))
                                            }}
                                        />
                                    </Col>
                                    <Col span={urlNumber?.some(fin => fin?.key === key) && urlNumber?.find(fin => fin?.key === key)?.value === "Xtreme Code API" ? 12: 12}>
                                        <MyInput
                                            label={'Name '+(name+1)}
                                            name={[name, 'name']}
                                            placeholder='e.g my m3u'
                                            required
                                            message='Please enter name'
                                        />
                                    </Col>
                                    <Col span={urlNumber?.some(fin => fin?.key === key) && urlNumber?.find(fin => fin?.key === key)?.value === "Xtreme Code API" ? 12: 12}>
                                        <MyInput
                                            label={'URL '+(name+1)}
                                            name={[name, 'url']}
                                            placeholder='e.g www.example.com'
                                            required
                                            message='Please enter url'
                                            value={form.getFieldValue("url") || ''}
                                        />
                                    </Col>
                                    {
                                        (urlNumber?.some(fin => fin?.key === key) && urlNumber?.find(fin => fin?.key === key)?.value === "Xtreme Code API")?
                                        <>
                                            <Col span={10}>
                                                <MyInput
                                                    label='Username'
                                                    name={[name, 'userName']}
                                                    placeholder='e.g myapi.er'
                                                    required
                                                    message='Please enter username'
                                                    value={form.getFieldValue("userName") || ''}
                                                />
                                            </Col>
                                            <Col span={11}>
                                                <MyInput
                                                    label='Password'
                                                    name={[name, 'password']}
                                                    placeholder='e.g myapi.er'
                                                    required
                                                    message='Please enter password'
                                                    value={form.getFieldValue("password") || ''}
                                                />
                                            </Col>
                                        </>
                                        :
                                        <></>
                                    }
                                    <Col span={3}>
                                        <Space className="align-center justify-end">
                                            <MySwitch
                                                label= {null}
                                                name={[name, 'isLock']}
                                                defaultChecked={false}
                                            />
                                            <ActionButton
                                                title='remove portal'
                                                icon={<MinusOutlined/>}
                                                onClick={() => {
                                                    setUrlNumber(urlNumber?.filter(fil => fil?.key !== key))
                                                    remove(name)
                                                }}
                                                danger
                                                style={{transform: 'translateY(5px)'}}
                                            />
                                        </Space>
                                    </Col>
                                    <Divider/>
                                </Row>
                            ))
                        }
                    </Space>
                )
            }
        </Form.List>
    )
}
export default Portals